import React, { useState, useEffect } from 'react';
import Spinner from '../Components/Spiner/Spinner'; // Ajusta la ruta si es necesario
import Topbar from '../Components/Topbar/TopBar';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import AppointmentComponent from '../Components/Appointments/Appointments'; // Asegúrate de que esta ruta sea correcta

const Appointment = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Topbar />
      <Navbar />
      <Spinner isLoading={isLoading} />
      {!isLoading && (
        <>
          <AppointmentComponent />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Appointment;

